<template>
  <v-dialog :value="dialogOpen" max-width="480" @click:outside="close">
    <div class="d-flex white">
      <CliChangeCard v-if="!isLoading" :product="product" @close="close"/>
      <Loader v-else />
    </div>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loader from "@/components/Misc/Loader";
import CliChangeCard from "./CliChangeCard";

export default {
  components: {
    Loader,
    CliChangeCard
  },

  props: ['product', 'dialogOpen'],

  watch: {
    async dialogOpen(open) {
      if(open){
        if(this.getTelcoTariffs[this.product.tariff_id]===undefined){
          let tarrifV = this.currentProduct.tariff_version.replace('TARIFF_V','');
          this.getAllTariffs({ version: tarrifV, supplier: '' });
        }
        this.getTelcoCliChangeReasons();
      }
    },
  },

  computed: {
    ...mapState("products", ["currentProduct"]),
    ...mapState('productCli', ['telcoCliChangeReasons', 'telcoCliChangeReasonsLoading']),
    ...mapGetters('products', ['getTelcoTariffs', 'getAllTariffsLoading', 'getCurrentProduct']),

    isLoading() {
      return [this.getAllTariffsLoading, this.telcoCliChangeReasonsLoading].includes(true);
    }
  },

  methods: {
    ...mapActions('products', ['getAllTariffs']),
    ...mapActions('productCli', ['changeCli', 'getTelcoCliChangeReasons']),

    close() {
      this.$emit('close-dialog');
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
